import { Spin } from 'antd';

export default function LoadingSpinner({ tip = 'Carregando...', size = 'large' }: { tip?: string; size?: 'small' | 'default' | 'large' }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px',
    }}>
      <Spin size={size} tip={tip} />
    </div>
  );
}
